import Splide from "@splidejs/splide";

export function carousel() {
  document.querySelectorAll(".aoris-carousel.splide").forEach((slider) => {
    // add the splide__slide class to the images, needed by splide
    slider.querySelectorAll(".wp-block-image").forEach((image) => {
      image.classList.add("splide__slide");
    });
    new Splide(slider).mount();
  });
}
